import { z } from 'zod';

/**
 * Espejo de `UserStateDataSchema` del backend (`api/users/schemas.ts`).
 *
 * Este archivo describia una forma que la API nunca devolvio: esperaba
 * `channels: [{channel, optedOut, preferences}]` y `recentNotifications`
 * como numero, cuando el backend manda `optOuts`, `preferences`, `budgets`
 * y `recentNotifications` como listas separadas mas `stats`. Con eso la
 * pantalla no podia funcionar ni aunque el request saliera bien (noten-itv).
 */

export const userPreferenceEntrySchema = z.object({
  channel: z.string(),
  messageCategory: z.string(),
  enabled: z.boolean(),
  source: z.enum(['user', 'tenant', 'default']),
});
export type UserPreferenceEntry = z.infer<typeof userPreferenceEntrySchema>;

export const userBudgetStateSchema = z.object({
  messageCategory: z.string(),
  weeklyLimit: z.number().nullable(),
  currentCount: z.number(),
  remaining: z.number().nullable(),
  source: z.enum(['user', 'tenant', 'app']),
});
export type UserBudgetState = z.infer<typeof userBudgetStateSchema>;

export const userRecentNotificationSchema = z.object({
  id: z.string(),
  channel: z.string(),
  messageCategory: z.string(),
  status: z.string(),
  createdAt: z.string(),
  deliveryAttempts: z.number(),
  lastError: z.string().optional(),
});
export type UserRecentNotification = z.infer<typeof userRecentNotificationSchema>;

export const userStatsSchema = z.object({
  totalSent: z.number(),
  delivered: z.number(),
  failed: z.number(),
  rejected: z.number(),
  deliveryRate: z.number(),
});
export type UserStats = z.infer<typeof userStatsSchema>;

export const userStateSchema = z.object({
  userId: z.string(),
  appId: z.string(),
  tenantId: z.string().nullable(),
  /** Secciones que la API no pudo resolver por falta de tenant. */
  unresolvedWithoutTenant: z.array(z.string()),
  optOuts: z.array(z.object({ channel: z.string() })),
  preferences: z.array(userPreferenceEntrySchema),
  budgets: z.array(userBudgetStateSchema),
  recentNotifications: z.array(userRecentNotificationSchema),
  stats: userStatsSchema,
});
export type UserState = z.infer<typeof userStateSchema>;
